import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { injectIntl, intlShape, FormattedMessage, defineMessages } from 'react-intl';
import { FieldErrorMessage } from 'react-components';
import Button from '@fenderdigital/react-button';
import FormValidation from '../../lib/form-validation';

const messages = defineMessages({
  placeholder: {
    id: 'footer.placeholder',
    defaultMessage: 'Enter your email to join our newsletter',
  },
  newsletter: {
    id: 'footer.newsletter',
    defaultMessage: 'Newsletter',
  },
  signup: {
    id: 'footer.signup',
    defaultMessage: 'sign up',
  },
  signupSuccess: {
    id: 'footer.signupSuccess',
    defaultMessage: 'Thanks for signing up!',
  },
  sending: {
    id: 'footer.sending',
    defaultMessage: 'Sending...',
  },
});
const formHeight = '3rem';
const inputStyle = 'input-reset ba b--black-20 source-sans outline-0 flex-auto f6 ph3';

class FooterEmailCapture extends PureComponent {
  constructor() {
    super();
    this.state = {
      error: {
        email: null,
      },
      disableBtn: true,
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(event) {
    event.persist();
    const { value } = event.target;
    this.setState(
      {
        [event.target.name]: value,
      },
      () => {
        const errorMessage = FormValidation.validate(event.target.name, value);
        this.setState(prevState => ({
          error: {
            ...prevState.error,
            [event.target.name]: errorMessage ? this.props.intl.formatMessage(errorMessage) : null,
          },
        }));
        const errors = this.validateFormFields();
        this.setState({
          disableBtn: errors !== null,
        });
      },
    );
  }

  onSubmit(event) {
    event.preventDefault();
    const { email } = this.state;
    const locale = window.navigator.language;
    this.props.createLead(email, locale);
  }

  validateFormFields() {
    return FormValidation.validateAll(['email'], this.state);
  }

  render() {
    const { intl } = this.props;
    const emailContainerStyle =
      'br1 br--left v-mid lh-solid inline-flex items-center white ttu bn bg-dark-gray ph3 pv2 f8';
    const emailAddressLabelStyle = {
      height: 0,
      width: 0,
      overflow: 'hidden',
    };
    return (
      <div className="footer-email-capture">
        <h6 className="dn-m dn-l tl ttu mt0 mb2 f6">
          <FormattedMessage {...messages.newsletter} />
        </h6>
        {!this.props.leadsSuccessStatus ? (
          <form
            className="flex h3 mb4"
            onSubmit={this.onSubmit}
            style={{ height: formHeight }}
            method="POST"
          >
            <div className="dn flex-ns">
              <div className={emailContainerStyle}>
                <FormattedMessage {...messages.newsletter} />
              </div>
            </div>
            <div className="flex flex-auto relative" data-id="footer-email-capture-input">
              <label htmlFor="emailAddress" style={emailAddressLabelStyle}>
                {intl.formatMessage(messages.placeholder)}
              </label>
              <input
                className={`${inputStyle}`}
                type="email"
                required
                name="email"
                id="emailAddress"
                onChange={this.onChange}
                placeholder={intl.formatMessage(messages.placeholder)}
              />
              <div
                className="error absolute top-2 mt3 left-0 w-100 shadow-4"
                data-id="footer-email-capture-error-message"
              >
                {this.state.error.email || this.props.leadsErrorStatus ? (
                  <FieldErrorMessage
                    message={this.state.error.email}
                    secondaryMessage={this.props.leadsErrorStatus}
                  />
                ) : null}
              </div>
            </div>
            <Button
              disabled={this.state.disableBtn}
              fontStyles="f8 futura-heavy ttu white"
              onClick={this.onSubmit}
              styles="br--right br1 ph3 bn"
              dataId="footer-email-capture"
            >
              {this.props.requestInProgress
                ? intl.formatMessage(messages.sending)
                : intl.formatMessage(messages.signup)}
            </Button>
          </form>
        ) : (
          <div className="f5 green mb4" data-id="footer-email-capture-success-message">
            <FormattedMessage {...messages.signupSuccess} />
          </div>
        )}
      </div>
    );
  }
}

FooterEmailCapture.propTypes = {
  intl: intlShape.isRequired,
  requestInProgress: PropTypes.bool.isRequired,
  createLead: PropTypes.func.isRequired,
  leadsSuccessStatus: PropTypes.bool.isRequired,
  leadsErrorStatus: PropTypes.string,
};

FooterEmailCapture.defaultProps = {
  leadsErrorStatus: null,
};

export default injectIntl(FooterEmailCapture);
